import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const DrawerStyled = styled.div`
    padding: 15px 0;
    position: relative;
    height: 100%;
    .title {
        font-size: 16px;
        font-weight: 600;
        color: #303641;
        min-height: 24px;
        display: flex;
        align-items: center;
        margin: 0 15px 15px;
    }
    .close {
        color: #c1c3c8;
        font-size: 24px;
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        margin-top: 5px;
    }

    .mobil-map {
        height: 100%;
        & > div,
        & > div > div {
            height: 100%;
        }
    }

    button.MuiButtonBase-root.MuiButton-containedInherit {
        background-color: #fff;
        color: #303641;
        font-weight: 600;
        font-size: 12px;
        border: 1px solid rgba(193, 195, 200, 0.4);
        box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
    }

    .mobil-filter-box {
        flex: 1;
        overflow: auto;
        padding: 10px 20px;
        .MuiAccordionSummary-root {
            padding: 0;
        }
        .MuiAccordionSummary-root.Mui-expanded {
            margin: 0;
            min-height: 48px;
            .MuiAccordionSummary-content {
                margin: 0;
            }
        }
        .MuiAccordion-root {
            border-top: 1px solid var(--mui-palette-text-light);
            margin: 0;
            ::before {
                display: none;
            }
        }
        .MuiAccordionDetails-root {
            display: flex;
            flex-direction: column;
            overflow: auto;
            max-height: 300px;
            padding: 0;
        }
        .filter-title {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            .filter {
                font-size: 16px;
                font-weight: 700;
            }
            .clear {
                color: #646a76;
                font-size: 14px;
                cursor: pointer;
            }
        }
        .form-label {
            .MuiTypography-root {
                font-size: 14px !important;
            }
        }
    }
`;
export const Mobile = css`
    & > .container {
        min-height: calc(100vh - 439px);
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    .search-bar-content {
        box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        background-color: #fff;
        margin-top: 24px;
        padding: 10px;
        border: 2px solid #0098c2;
    }
    .page-container {
        margin: 0px;
        margin-bottom: 30px;
        .right {
            .mobile-buttons {
                display: flex;
                gap: 10px;
                button {
                    background-color: #fff;
                    color: #303641;
                    font-weight: 600;
                    font-size: 12px;
                    box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
                }
            }
        }
    }

    .page-content {
        border-radius: 6px;
        background-color: #fff;
        padding: 30px 40px;
        color: #303641;
        display: flex;
        flex-direction: column;
        font-size: 14px;
    }
`;
export const Tablet = css`
    .page-container {
        margin: 0px;
        margin-bottom: 30px;
        .left {
            display: none;
        }
        .right {
            .mobile-buttons {
                display: flex;
                gap: 10px;
                button {
                    background-color: #fff;
                    color: #303641;
                    font-weight: 600;
                    font-size: 12px;
                    box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
                }
            }
        }
    }
    .search-bar-content {
        box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        background-color: #fff;
        margin-top: 24px;
        padding: 18px;
        border: 2px solid #0098c2;
    }

    .page-city-container {
        .page-header {
            .register-box {
                display: none !important;
            }
            .map-box {
                flex: 1;
            }
        }
    }
`;

export const DialogMapStyledMobile = css`
    /* min-width: 360px; */

    width: 100%;
    color: #303641;
    position: relative;
    .toggle-buttons {
        width: 100%;
        margin: auto;
        position: relative;
        bottom: 10px;

        .button-group {
            border-radius: 6px !important;
            background-color: var(--mui-palette-primary-main);
            width: 100%;
            margin-top: 15px;
            margin-bottom: 10px;
            button {
                .flight-icon {
                    transform: rotate(90deg);
                }
            }
            .MuiButtonBase-root {
                padding: 8px 25px;
                border-color: transparent;
                border-radius: 6px !important;
                text-transform: inherit;
                color: #fff;
                width: 100%;
                text-align: center;
                white-space: nowrap;

                &.Mui-selected {
                    background-color: var(--mui-palette-primary-main);
                    color: white;
                }

                &.active {
                    background-color: var(--mui-palette-secondary-main);
                }
            }
        }
    }

    .MuiDialogTitle-root {
        font-size: 16px;
        font-weight: 700;
    }
    .close {
        position: absolute;
        top: 10px;
        right: 15px;
        opacity: 0.6;
    }

    .window {
        display: flex;
        flex-direction: row;
        gap: 24px;

        .content {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 100%;
            background-color: #f0f4f9;
            border-radius: 12px;
            padding: 15px;
            .airline {
                background-color: #fff;
                border-radius: 12px;
                padding: 15px;
                .table {
                    white-space: nowrap;
                    font-size: 14px;
                    th {
                        font-size: 14px;
                        font-weight: 600;
                    }
                }
            }
            .table {
                font-size: 12px;
                text-align: left;
                vertical-align: middle;
                .icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }
                .custom-td {
                    padding-left: 10px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                th {
                    font-size: 16px;
                }
            }
        }

        .flight-map {
            min-width: 300px;
            width: 644px;
            overflow: hidden;
            border-radius: 12px;
            position: relative;
            z-index: 10;
            &.fullscreen {
                z-index: 999999;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }

    .line-container {
        background-color: #f0f4f9;
        border-radius: 12px;
        margin-top: 24px;
        padding: 15px;

        .head-line {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex: 1;
            margin-bottom: 15px;
            .left,
            .right {
                gap: 10px;
                display: flex;
                flex-direction: row;
            }
            .left-button,
            .right-button {
                padding: 2px 7px;
                background-color: #fff;
                color: #303641;
                font-weight: 600;
                box-shadow: none;
                font-size: 12px;
                min-width: 0;
                .icon {
                    color: var(--mui-palette-primary-main);
                    font-size: 100%;
                    margin-right: -4px;
                }
            }
        }

        .footer-line {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex: 1;
            margin-top: 15px;
            .left,
            .right {
                gap: 10px;
                display: flex;
                flex-direction: row;
                font-size: 12px;
                color: #303641;
                font-weight: 600;
            }
        }
        .line {
            margin: 5px 0;
            width: 100%;
            height: 1px;
            background-image: repeating-linear-gradient(
                to right,
                transparent,
                transparent,
                rgb(0 152 194 / 44%) 4px,
                rgb(0 152 194 / 44%) 8px
            );
            position: relative;
            &::after {
                content: '';
                width: 12px;
                height: 12px;
                background-color: #fff;
                border: 3px solid var(--mui-palette-primary-main);
                position: absolute;
                right: 0px;
                top: -5px;
                border-radius: 100%;
            }
            .fill {
                z-index: 3;
                position: relative;
                top: -2px;
                min-width: 18px;
                height: 5px;
                background-color: var(--mui-palette-primary-main);
                outline: 2px rgb(0 152 194 / 20%) solid;
                left: 2px;
                border-radius: 4px;
                &::before {
                    content: '';
                    width: 12px;
                    height: 12px;
                    background-color: var(--mui-palette-primary-main);
                    position: absolute;
                    left: -2px;
                    top: -3px;
                    border-radius: 100%;
                }
                .after {
                    width: 20px;
                    height: 20px;
                    background-color: var(--mui-palette-primary-main);
                    position: absolute;
                    right: -2px;
                    top: -8px;
                    border-radius: 100%;
                    outline: 3px solid #f0f4f9;
                    transform: rotate(90deg);
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > * {
                        font-size: 14px;
                    }
                }
            }
        }
    }
`;

export const DialogMapStyled = styled.div`
    min-width: 360px;
    color: #303641;
    position: relative;
    padding: 0px;
    .MuiDialogContent-root {
        padding: 0px;
    }
    .MuiDialogTitle-root {
        font-size: 16px;
        font-weight: 700;
    }
    .close {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 5px;
        z-index: 9999;
        color: #303641;
        background-color: #fff !important;
        &:hover {
            background-color: #f0f4f9 !important;
        }
    }

    .window {
        display: flex;
        flex-direction: row;
        gap: 24px;

        .content {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 282px;
            background-color: #f0f4f9;
            border-radius: 12px;
            padding: 15px;
            .airline {
                background-color: #fff;
                border-radius: 12px;
                padding: 15px;
                .table {
                    white-space: nowrap;
                    font-size: 14px;
                    th {
                        font-size: 14px;
                        font-weight: 600;
                    }
                }
            }
            .table {
                font-size: 12px;
                text-align: left;
                vertical-align: middle;
                .icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }
                .custom-td {
                    padding-left: 10px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                th {
                    font-size: 16px;
                }
            }
        }

        .flight-map {
            min-width: 300px;
            width: 644px;
            overflow: hidden;
            border-radius: 12px;
            position: relative;
            z-index: 10;
        }
    }

    .line-container {
        background-color: #f0f4f9;
        border-radius: 12px;
        margin-top: 24px;
        padding: 15px;

        .head-line {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex: 1;
            margin-bottom: 15px;
            .left,
            .right {
                gap: 10px;
                display: flex;
                flex-direction: row;
            }
            .left-button,
            .right-button {
                padding: 2px 7px;
                background-color: #fff;
                color: #303641;
                font-weight: 600;
                box-shadow: none;
                font-size: 12px;
                min-width: 0;
                .icon {
                    color: var(--mui-palette-primary-main);
                    font-size: 100%;
                    margin-right: -4px;
                }
            }
        }

        .footer-line {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex: 1;
            margin-top: 15px;
            .left,
            .right {
                gap: 10px;
                display: flex;
                flex-direction: row;
                font-size: 12px;
                color: #303641;
                font-weight: 600;
            }
        }
        .line {
            margin: 5px 0;
            width: 100%;
            height: 1px;
            background-image: repeating-linear-gradient(
                to right,
                transparent,
                transparent,
                rgb(0 152 194 / 44%) 4px,
                rgb(0 152 194 / 44%) 8px
            );
            position: relative;
            &::after {
                content: '';
                width: 12px;
                height: 12px;
                background-color: #fff;
                border: 3px solid var(--mui-palette-primary-main);
                position: absolute;
                right: 0px;
                top: -5px;
                border-radius: 100%;
            }
            .fill {
                z-index: 3;
                position: relative;
                top: -2px;
                min-width: 18px;
                height: 5px;
                background-color: var(--mui-palette-primary-main);
                outline: 2px rgb(0 152 194 / 20%) solid;
                left: 2px;
                border-radius: 4px;
                &::before {
                    content: '';
                    width: 12px;
                    height: 12px;
                    background-color: var(--mui-palette-primary-main);
                    position: absolute;
                    left: -2px;
                    top: -3px;
                    border-radius: 100%;
                }
                .after {
                    width: 20px;
                    height: 20px;
                    background-color: var(--mui-palette-primary-main);
                    position: absolute;
                    right: -2px;
                    top: -8px;
                    border-radius: 100%;
                    outline: 3px solid #f0f4f9;
                    transform: rotate(90deg);
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > * {
                        font-size: 14px;
                    }
                }
            }
        }
    }

    ${mediaQuery.lessThan('xltablet')`${DialogMapStyledMobile}`}
`;

export const Styled = styled.div`
    & > .container {
        min-height: calc(100vh - 439px);
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .search-bar-content {
        padding: 18px;
        box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        background-color: #fff;
        margin-top: 24px;
    }

    .page-container {
        margin: 24px 0;
        display: flex;
        flex-direction: row;
        gap: 24px;
        position: relative;
        .page-content {
            border-radius: 6px;
            background-color: #fff;
            padding: 30px 40px;
            color: #303641;
            display: flex;
            flex-direction: column;
            font-size: 14px;
        }
        .bnr {
            width: 100%;
            border-radius: 8px;
        }

        .page-header {
            display: flex;
            flex-direction: column;
            gap: 18px;

            .sort-box {
                display: flex;
                flex-direction: row;

                flex-wrap: wrap;
                justify-content: space-between;
                gap: 12px;
                & > button {
                    width: auto;
                    flex: 1;
                    background-color: #fff;
                    border-color: transparent;
                    box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
                    color: #303641;
                    font-weight: 600;
                    font-size: 14px;
                    &.MuiButton-outlinedPrimary {
                        border-color: inherit;
                        color: #0098c2;
                    }
                }
            }
            .info-alert {
                padding: 0;
                background-color: transparent;
                color: #646a76;
            }
        }
        .card-box {
            .infinite-scroll-component {
                overflow: hidden !important;
                padding: 12px;
                margin: -12px;
            }
            .card-list {
                display: flex;
                flex-direction: column;
                gap: 24px;
            }
        }

        .filter-box {
            border-radius: 12px;
            background-color: #fff;
            filter: drop-shadow(3px 3px 24px rgba(0, 0, 0, 0.05));
            padding: 10px 20px;
            .MuiAccordionSummary-root {
                padding: 0;
            }
            .MuiAccordionSummary-root.Mui-expanded {
                margin: 0;
                min-height: 48px;
                .MuiAccordionSummary-content {
                    margin: 0;
                }
            }
            .MuiAccordion-root {
                border-top: 1px solid var(--mui-palette-text-light);

                margin: 0;
                ::before {
                    display: none;
                }
            }
            .MuiAccordionDetails-root {
                display: flex;
                flex-direction: column;
                overflow: auto;
                max-height: 300px;
                padding: 0;
            }
            .filter-title {
                display: flex;
                justify-content: space-between;
                padding: 10px 0;
                .filter {
                    font-size: 16px;
                    font-weight: 700;
                }
                .clear {
                    color: #646a76;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
            .form-label {
                .MuiTypography-root {
                    font-size: 14px !important;
                }
            }
        }
        .sticky {
            top: 24px;
            position: sticky;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;
            height: max-content;
        }
        & > .left {
            width: 270px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
        & > .right {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
        .map-box {
            position: relative;
        }

        .image-container {
            cursor: pointer;
            position: relative;
            width: 100%;
            border: 1px solid rgba(193, 195, 200, 0.4);
            overflow: hidden;
            border-radius: 12px;
            aspect-ratio: 16/7;
        }

        .image-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            user-select: none;
        }

        .centered-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            min-width: 190px;
            font-weight: 600;
        }
    }

    .error-box {
        max-width: 310px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 100px auto;
        .icon {
            background-color: #e6f5f9;
            color: #0098c2;
            border-radius: 6px;
            width: 58px;
            height: 58px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 15px;
            svg {
                font-size: 32px;
            }
        }
        .text {
            text-align: center;
            color: #303641;
            font-size: 14px;
            b {
                font-weight: 600;
            }
        }
    }
    .banner {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 100%;
        padding: 20px 0;
    }

    .banner img {
        margin: 0;
    }

    .page-city-container {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 24px;
        position: relative;
        max-width: 960px;
        width: 100%;

        .page-header {
            display: flex;
            flex-direction: row;
            gap: 24px;

            .register-box {
                flex: 1;
                background-image: url('/assets/images/register-box-bg.jpg');
                background-position: center right;
                background-size: contain cover;
                background-repeat: no-repeat;
                background-color: #2497c3;
                border-radius: 8px;
                overflow: hidden;
                object-fit: cover;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                padding: 0 14px;
                cursor: pointer;
                .text {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 10px;
                    .MuiSvgIcon-root {
                        color: #0098c2;
                        background-color: #fff;
                        border-radius: 100%;
                        padding: 3px;
                        width: 28px;
                        height: 28px;
                    }
                    span {
                        color: #fff;
                        font-size: 14px;
                        font-weight: 700;
                    }
                }
            }
            .map-box {
                position: relative;

                .image-container {
                    cursor: pointer;
                    position: relative;
                    border: 1px solid rgba(193, 195, 200, 0.4);
                    overflow: hidden;
                    border-radius: 8px;
                    height: 48px;
                    text-align: center;
                }

                .image-container img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    user-select: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 0;
                }

                .centered-button {
                    position: relative;
                    z-index: 2;
                    min-width: 146px;
                    font-weight: 600;
                    white-space: nowrap;
                    margin: 8px;
                }
            }
        }
        .card-box {
            margin-bottom: 24px;
            .infinite-scroll-component {
                overflow: hidden !important;
            }
            .card-list {
                display: flex;
                flex-direction: column;
                gap: 24px;
            }
        }
    }

    .h-title {
        color: #303641 !important;
        font-size: 18px !important;
        font-weight: 700 !important;
        margin: 0;
        small {
            font-size: 14px;
            font-weight: 400;
        }
    }
    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
`;
